import { redirectIfAuthenticated } from '@/lib/auth-redirect'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { GridBackGround } from '@/components/ui/grid-background'
import { ThemeToggle } from '@/components/shared/theme-toggle'
import { GlowingEffect } from '@/components/ui/glowing-effect'
import { MobileDownloadView } from '@/components/auth/mobile-download-view'
import { useIsMobile } from '@/hooks/use-mobile'
import logoImg from '@/assets/logo.png'

export const Route = createFileRoute('/(auth)')({
  beforeLoad: redirectIfAuthenticated,
  component: AuthLayout,
})

function AuthLayout() {
  const isMobile = useIsMobile()

  // Mobile: Show app download smart banner
  if (isMobile) {
    return <MobileDownloadView />
  }

  // Desktop: Show normal login layout
  return (
    <div className="relative grid min-h-svh lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <GridBackGround 
          logo={
            <a href="#" className="flex items-center gap-2 font-medium mb-8">
              <img 
                src={logoImg} 
                alt="EasyDo" 
                className="h-10 w-auto"
              />
              <span className="text-white/70 text-4xl font-semibold">EasyDo 365</span>
            </a>
          }
          title="Office in your pocket"
          subtitle={`Focus on growing the business
and leave the rest to easydo 365`}
        />
      </div>
      <div className="relative flex flex-col gap-4 p-6 md:p-10 bg-gray-50 dark:bg-black/80 border-l">
        <div className="absolute top-6 right-6">
          <ThemeToggle />
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-[350px] relative">
            <div className="relative rounded-lg border bg-card shadow-lg p-8 min-h-[350px] flex flex-col justify-center">
              <GlowingEffect
                spread={40}
                glow={true}
                disabled={false}
                proximity={64}
                inactiveZone={0.01}
              />
              <div className="relative z-10">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}